<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted: function () {
    window.document.title = `${window.SchoolSettings.name} Enrolments`;
  },
};
</script>
